import { render, staticRenderFns } from "./PccBookerDocumentList.vue?vue&type=template&id=1e957569&scoped=true&"
import script from "./PccBookerDocumentList.vue?vue&type=script&lang=js&"
export * from "./PccBookerDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e957569",
  null
  
)

export default component.exports